const defaultRetryOption = {
  retries: 5,
  intervalSeconds: 1,
};

type Option = Partial<typeof defaultRetryOption>;

export const withRetry = <T>(func: () => Promise<T>, option?: Option): Promise<T> =>
  new Promise((resolve, reject) =>
    func()
      .then((result) => resolve(result))
      .catch((error) => {
        const { retries, intervalSeconds } = {
          ...defaultRetryOption,
          ...option,
        };

        if (retries === 0) {
          if (error instanceof Error) {
            return reject(error);
          }
          return reject(new Error(`Error: ${error}`));
        }

        return setTimeout(
          () => resolve(withRetry(func, { retries: retries - 1, intervalSeconds })),
          intervalSeconds * 1000
        );
      })
  );
